import { useState, useEffect } from "react";
import { Box, Button, Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { createCommissionDispatch } from "../../store/reducers/userProfileReducer";
import Title from "../../components/ReusableComponents/title";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import copyIcon from "../../assets/icons/copy-white.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { axiosInstance } from "../../Axios";

function CreateAffiliate() {
  const dispatch = useDispatch();
  const { url, referalCode } = useSelector((state) => state.user);
  const ACCtoken = useSelector((state) => state.ACCtoken);
  const [link, setLink] = useState(false);

  const [isSuperAffiliate, setIsSuperAffiliate] = useState(false);
  const [codeGenType, setCodeGenType] = useState("random"); // "random" or "custom"
  const [customCode, setCustomCode] = useState("");

  const [showPopup, setShowPopup] = useState(false);
  const [popupHead, setPopupHead] = useState("");
  const [popupBody, setPopupBody] = useState("");
  const [popupType, setPopupType] = useState("");

  useEffect(() => {
    const checkSuperAffiliate = async () => {
      if (!ACCtoken) return;
      try {
        const res = await axiosInstance.get("v2/is-user/super-affiliate/", {
          headers: {
            Authorization: `Bearer ${ACCtoken}`,
          },
        });
        console.log(res, "resres");
        const isSuper = !!res.data?.is_super_affiliate;
        setIsSuperAffiliate(isSuper);
      } catch (err) {
        console.error("Error checking super affiliate status:", err);
      }
    };
    checkSuperAffiliate();
  }, [ACCtoken]);

  const handleSubmit = async () => {
    if (isSuperAffiliate && codeGenType === "custom" && !customCode.trim()) {
      toast.error("Please enter a custom affiliate code.");
      return;
    }

    try {
      const payload = {};
      if (isSuperAffiliate && codeGenType === "custom" && customCode.trim()) {
        payload.code = customCode.trim();
      }
      const res = await dispatch(createCommissionDispatch(payload));

      if (res.status && res.status !== 200) {
        setPopupHead("Error");
        setPopupBody(
          res.detail ||
            res.message ||
            "Something went wrong. Please try again!",
        );
        setPopupType("error");
      } else {
        setLink(true);
        setPopupHead("Woo Hoo");
        setPopupBody("Affiliate Link successfully created");
        setPopupType("success");
      }
    } catch (err) {
      setPopupHead("Error");
      setPopupBody(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          err.message ||
          "Something went wrong. Please try again!",
      );
      setPopupType("error");
    } finally {
      setShowPopup(true);
    }
  };

  const showToast = (message) => {
    toast.success(message, {
      position: "top-right",
      duration: 2000,
      className: "custom-toast-container",
      style: { background: "#333", color: "#fff" },
    });
  };

  const handleCopyToClipboard = (text) => {
    if (text) {
      showToast("Affiliate link copied.");
    }
  };

  // Extract affiliate code from URL
  const affiliateCode = url?.replace(
    "https://app.alphacapitalgroup.uk/signup/",
    "",
  );

  return (
    <Box>
      <Grid container spacing={2} style={{ textAlign: "left" }}>
        <Grid item xs={12}>
          <Title sx={{ mb: 2 }}>Create Affiliate Code</Title>
          <Box className="create_affiliate_code">
            <Box className="info_box">
              {isSuperAffiliate && !link && (
                <Box className="custom_code_section" sx={{ width: "100%", maxWidth: "600px", mb: 3, display: "flex", flexDirection: "column", gap: "15px" }}>
                  <p className="title" style={{ color: "#f6f6f6", fontFamily: "Outfit", fontSize: "16px", marginBottom: "0px" }}>Affiliate Code Type</p>
                  
                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", width: "100%" }}>
                    <Box
                      onClick={() => setCodeGenType("random")}
                      sx={{
                        flex: 1,
                        minWidth: "220px",
                        padding: "16px 20px",
                        borderRadius: "12px",
                        border: codeGenType === "random" ? "1px solid #0d56eb" : "1px solid rgba(255, 255, 255, 0.08)",
                        background: codeGenType === "random" ? "rgba(13, 86, 235, 0.08)" : "rgba(159, 159, 159, 0.02)",
                        cursor: "pointer",
                        transition: "all 0.2s ease-in-out",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        textAlign: "left",
                        "&:hover": {
                          border: "1px solid #0d56eb",
                          background: codeGenType === "random" ? "rgba(13, 86, 235, 0.08)" : "rgba(13, 86, 235, 0.03)"
                        }
                      }}
                    >
                      <span style={{ color: "#fff", fontFamily: "Outfit", fontSize: "15px", fontWeight: "600" }}>
                        Random Code
                      </span>
                      <span style={{ color: "#8f8f8f", fontFamily: "Outfit", fontSize: "12px" }}>
                        System generated unique code
                      </span>
                    </Box>

                    <Box
                      onClick={() => setCodeGenType("custom")}
                      sx={{
                        flex: 1,
                        minWidth: "220px",
                        padding: "16px 20px",
                        borderRadius: "12px",
                        border: codeGenType === "custom" ? "1px solid #0d56eb" : "1px solid rgba(255, 255, 255, 0.08)",
                        background: codeGenType === "custom" ? "rgba(13, 86, 235, 0.08)" : "rgba(159, 159, 159, 0.02)",
                        cursor: "pointer",
                        transition: "all 0.2s ease-in-out",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        textAlign: "left",
                        "&:hover": {
                          border: "1px solid #0d56eb",
                          background: codeGenType === "custom" ? "rgba(13, 86, 235, 0.08)" : "rgba(13, 86, 235, 0.03)"
                        }
                      }}
                    >
                      <span style={{ color: "#fff", fontFamily: "Outfit", fontSize: "15px", fontWeight: "600" }}>
                        Custom Code
                      </span>
                      <span style={{ color: "#8f8f8f", fontFamily: "Outfit", fontSize: "12px" }}>
                        Choose your own custom affiliate code
                      </span>
                    </Box>
                  </Box>

                  {codeGenType === "custom" && (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%", mt: 1 }}>
                      <p className="title" style={{ color: "#f6f6f6", fontFamily: "Outfit", fontSize: "16px", marginBottom: "0px" }}>Custom Affiliate Code</p>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, position: "relative", width: "100%" }}>
                        <input
                          placeholder="Enter your custom affiliate code"
                          type="text"
                          value={customCode}
                          onChange={(e) => setCustomCode(e.target.value)}
                          className="affiliate-code-input"
                          style={{
                            color: "#fff",
                            width: "100%",
                            height: "60px",
                            padding: "10px 20px",
                            borderRadius: "10px",
                            border: "1px solid var(--Gradient-1, #005afd)",
                            background: "rgba(159, 159, 159, 0.05)",
                            fontFamily: "Outfit",
                            fontSize: "15px",
                            outline: "none"
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>
              )}
              {link && (
                <Box className="input_wrapper">
                  <p className="title">Your Affiliate Link</p>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <input
                      placeholder="Your full affiliate link will appear here"
                      type="text"
                      value={link ? url : ""}
                      disabled
                      className="affiliate-code-input"
                      readOnly
                    />
                    <CopyToClipboard
                      text={url}
                      onCopy={() => handleCopyToClipboard(url)}
                      disabled={!link || !url}
                    >
                      <Button
                        className="copy_btn"
                        variant="outlined"
                        startIcon={<img src={copyIcon} alt="Copy icon" />}
                        disabled={!link || !url}
                      >
                        Copy Link
                      </Button>
                    </CopyToClipboard>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <input
                      placeholder="Your affiliate code will appear here"
                      type="text"
                      value={link ? affiliateCode : ""}
                      disabled
                      className="affiliate-code-input"
                      readOnly
                    />
                    <CopyToClipboard
                      text={affiliateCode}
                      onCopy={() => handleCopyToClipboard(affiliateCode)}
                      disabled={!link || !affiliateCode}
                    >
                      <Button
                        className="copy_btn"
                        variant="outlined"
                        startIcon={<img src={copyIcon} alt="Copy icon" />}
                        disabled={!link || !affiliateCode}
                      >
                        Copy Code
                      </Button>
                    </CopyToClipboard>
                  </Box>
                </Box>
              )}
              <Box className="btn_wrapper" sx={{ mt: 1 }}>
                <Button
                  className="unique-code-generate-button"
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: "15px",
                    textTransform: "capitalize",
                  }}
                >
                  {isSuperAffiliate && codeGenType === "custom" ? "Create Custom Affiliate Code" : "Generate your Affiliate Code"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {showPopup && (
        <CombinedPopup
          head={popupHead}
          subhead={popupBody}
          type={popupType}
          trigger={showPopup}
          setTrigger={setShowPopup}
        />
      )}
    </Box>
  );
}

export default CreateAffiliate;
